export function parseInline(text, opts) {
    const q = opts?.singleQuoteLinks ? "'" : '"';
    let result = '';
    let i = 0;
    while (i < text.length) {
        // Bold + Italic: ***...***
        if (text[i] === '*' && text[i + 1] === '*' && text[i + 2] === '*') {
            const end = findClosing(text, i + 3, '***');
            if (end !== -1) {
                const content = text.slice(i + 3, end);
                result += '<b><i>' + parseInline(content, opts) + '</i></b>';
                i = end + 3;
                continue;
            }
        }
        // Bold: **...**
        if (text[i] === '*' && text[i + 1] === '*') {
            const end = findClosing(text, i + 2, '**');
            if (end !== -1) {
                const content = text.slice(i + 2, end);
                result += '<b>' + parseInline(content, opts) + '</b>';
                i = end + 2;
                continue;
            }
        }
        // Italic: *...*
        // Not italic if followed by space or [
        if (text[i] === '*' && i + 1 < text.length && text[i + 1] !== ' ' && text[i + 1] !== '[' && text[i + 1] !== '*') {
            const end = findClosingStar(text, i + 1);
            if (end !== -1) {
                const content = text.slice(i + 1, end);
                result += '<i>' + parseInline(content, opts) + '</i>';
                i = end + 1;
                continue;
            }
            // Italic fallback: * opens but can't close before \n.
            // Consume * + content up to \n + the \n itself (merges lines).
            // This replicates PEG behavior where the italic fallback rule
            // consumes newlines, keeping consecutive lines in the same paragraph.
            result += '*';
            i++;
            while (i < text.length && text[i] !== '*' && text[i] !== '\n') {
                result += text[i];
                i++;
            }
            if (i < text.length && text[i] === '\n') {
                i++; // consume \n without adding to result
            }
            continue;
        }
        // Double bracket constructs: [[...]]
        if (text[i] === '[' && text[i + 1] === '[') {
            const parsed = parseBracketConstruct(text, i, q);
            if (parsed) {
                result += parsed.html;
                i = parsed.end;
                continue;
            }
        }
        // Single bracket construct: [content] - consume as plain text
        // Matches PEG plainTextSection = "[" [^\]\[]* "]"
        if (text[i] === '[' && text[i + 1] !== '[') {
            const closeIdx = text.indexOf(']', i + 1);
            if (closeIdx !== -1 && !text.slice(i + 1, closeIdx).includes('[') && !text.slice(i + 1, closeIdx).includes(']')) {
                result += text.slice(i, closeIdx + 1);
                i = closeIdx + 1;
                continue;
            }
        }
        // Plain text character
        result += text[i];
        i++;
    }
    return result;
}
function findClosing(text, start, marker) {
    // Find closing marker. Content must not contain newline.
    // Content between markers matches [^*\n]+ (non-star, non-newline, at least 1 char)
    if (start >= text.length)
        return -1;
    for (let j = start; j < text.length; j++) {
        if (text[j] === '\n')
            return -1;
        if (text[j] === '*') {
            // Check if this is the start of our closing marker
            if (marker === '***' && text[j + 1] === '*' && text[j + 2] === '*') {
                if (j > start)
                    return j;
                return -1;
            }
            if (marker === '**' && text[j + 1] === '*') {
                if (j > start)
                    return j; // need at least 1 char of content
                return -1;
            }
        }
    }
    return -1;
}
function findClosingStar(text, start) {
    // Find a single closing * (not **). Content must not contain * or newline.
    for (let j = start; j < text.length; j++) {
        if (text[j] === '\n')
            return -1;
        if (text[j] === '*') {
            // If it's a double star, skip both
            if (text[j + 1] === '*') {
                j++;
                continue;
            }
            return j;
        }
    }
    return -1;
}
function parseBracketConstruct(text, start, q) {
    // start points to the first [
    // Find matching ]]
    const inner = extractBracketContent(text, start + 2);
    if (inner === null)
        return null;
    const content = inner.content;
    const end = inner.end; // position after ]]
    // Image
    if (content.startsWith('image:')) {
        const src = content.slice(6);
        return { html: `<img src='${src}'>`, end };
    }
    // Link
    const pipeIdx = content.indexOf('|');
    if (pipeIdx !== -1) {
        const url = content.slice(0, pipeIdx);
        const linkText = content.slice(pipeIdx + 1);
        return {
            html: `<a class="external" target="_blank" rel="noopener noreferrer" href=${q}${url}${q}>${linkText}</a>`,
            end,
        };
    }
    // Unnamed link
    return {
        html: `<a class="external" target="_blank" rel="noopener noreferrer" href=${q}${content}${q}>${content}</a>`,
        end,
    };
}
function extractBracketContent(text, start) {
    // Starting after [[, find matching ]]
    // Content can contain anything except ]] (handled by looking for ]])
    let j = start;
    while (j < text.length - 1) {
        if (text[j] === ']' && text[j + 1] === ']') {
            return { content: text.slice(start, j), end: j + 2 };
        }
        j++;
    }
    return null;
}
